import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CheckoutApiService } from '@app/pages/checkout-app/services';
import { ABTestGroupDTO } from '../../dialogs/abtest-dialog/abtest-group.dto';
import { Subscription, throwError } from 'rxjs';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { CreateAbTestGroupDialogComponent } from '../../dialogs/create-abtest-group-dialog/create-ab-test-group-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { PdqToastComponent } from '@app/storybook/components/toast/toast.component';
import { TimeUnits } from '@utils/times-utils';

@Component({
  selector: 'choose-abtest-group',
  templateUrl: './choose-abtest-group.component.html',
  styleUrls: ['./choose-abtest-group.component.scss'],
  standalone: false,
})
export class ChooseABTestGroupComponent implements OnInit, OnDestroy {
  @Input() prepopulatedGroupId: number;
  @Input() disabled: boolean;
  @Output() onABTestGroupSelected = new EventEmitter<ABTestGroupDTO>();

  results: DropdownOption[] = [];
  defaultOption: DropdownOption;
  fetchAbTestGroupsSubscription$: Subscription;
  constructor(
    private dialog: MatDialog,
    private checkoutApiService: CheckoutApiService,
    private toastService: ToastService,
  ) {}
  ngOnDestroy(): void {
    this.fetchAbTestGroupsSubscription$?.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.results.length) {
      this.fetchAbTestGroupsSubscription$ = this.fetchAbTestGroups().subscribe(
        (response: ABTestGroupDTO[]) => {
          this.results = response
            .sort((x) => new Date(x.createdAt).getTime())
            .map((x) => {
              return { label: x.name, value: x.id, value2: x.description };
            });
          if (this.prepopulatedGroupId > 0) {
            this.defaultOption = this.results.find((x) => x.value == this.prepopulatedGroupId);
          }
        },
        (err) => {
          return throwError(err);
        },
      );
    }
  }

  fetchAbTestGroups() {
    return this.checkoutApiService.get(`admin/v1/ab-test-group`);
  }

  changeABTestGroupDropdown(dropdownOption?: DropdownOption | undefined) {
    if (!dropdownOption) {
      this.defaultOption = undefined;
      this.onABTestGroupSelected.emit(undefined);
      return;
    }

    const abTestGroup = new ABTestGroupDTO();
    abTestGroup.id = dropdownOption.value as number;
    abTestGroup.name = dropdownOption.label;
    abTestGroup.description = dropdownOption.value2 as string;
    this.onABTestGroupSelected.emit(abTestGroup);
  }

  createABTestGroupClick(event) {
    const dialogRef = this.dialog.open(CreateAbTestGroupDialogComponent, {
      data: {},
    });
    dialogRef.componentInstance.onSave.subscribe((newGroup) => {
      const option = { label: newGroup.name, value: newGroup.id, value2: newGroup.description };
      this.results = [option, ...this.results];
      this.defaultOption = option;
      this.onABTestGroupSelected.emit(newGroup);
      this.toastService.show(PdqToastComponent, {
        position: 'top',
        mode: 'success',
        message: `Successfully created A/B test group ${newGroup.name}!`,
        duration: TimeUnits._SECOND_IN_MS * 3,
      });
    });
  }
}
